import * as THREE from "three";
import { flatWhite } from "./materials.ts";
import {
  HEX_RADIUS,
  HEX_SIDE,
  WALL_COUNT,
  WALL_HEIGHT,
  WALL_SLOTS,
  WALL_THICKNESS,
} from "./hex.ts";

// The hexagonal party room: a flat hexagon floor + six walls (one per edge),
// each facing the centre. Flat white fills; the black line comes from the edges.
export function createRoom(): THREE.Group {
  const room = new THREE.Group();
  room.name = "room";

  // Floor: a flat hexagon (vertices at k·60°, circumradius R).
  const shape = new THREE.Shape();
  for (let i = 0; i < WALL_COUNT; i++) {
    const a = i * ((2 * Math.PI) / WALL_COUNT);
    const x = Math.cos(a) * HEX_RADIUS;
    const y = Math.sin(a) * HEX_RADIUS;
    if (i === 0) shape.moveTo(x, y);
    else shape.lineTo(x, y);
  }
  shape.closePath();
  const floor = new THREE.Mesh(new THREE.ShapeGeometry(shape), flatWhite());
  floor.rotation.x = Math.PI / 2; // lay flat: shape (x,y) → world (x,0,y)
  (floor.material as THREE.MeshBasicMaterial).side = THREE.DoubleSide;
  room.add(floor);

  // Six walls, one per hexagon edge, facing the centre.
  for (const slot of WALL_SLOTS) {
    const wall = new THREE.Mesh(
      new THREE.BoxGeometry(HEX_SIDE, WALL_HEIGHT, WALL_THICKNESS),
      flatWhite(),
    );
    wall.position.set(slot.x, WALL_HEIGHT / 2, slot.z);
    wall.lookAt(0, WALL_HEIGHT / 2, 0); // +Z faces the centre
    room.add(wall);
  }

  return room;
}
